import ReviewandApproval from "../../../../src/pages/use-cases/page-content/collaboration/review-and-approval.md";
import * as React from 'react';
export default {
  ReviewandApproval,
  React
};